<template>
  <div  v-redirect-if-no-permission:CARLO_PAYMENT>

    <DataTable ref="paymentsDataTable" :url="api.ACTIONS.payments" :titles="titles" :fields-hidden-main="[]"
      :title="$t('settings.payments.title')" :enableEdit="false" :enableAdd="false" :enableDelete="false" :sortable="false"
      :actions-extra-main="actionsExtraMain"  :formatter="formatter"  :conditional-action="conditionalAction" />
  </div>
</template>

<style>
.hbtn {
  float: right;
  z-index: 1;
  margin-top: 20px;
  margin-right: 20px;
  padding: 0px 45px;
}
</style>

<script>
import DataTable from "@/components/monaco/DataTable";
import moment from "moment";
import i18n from "@/i18n";

const required = (val) =>
  (val !== null && val !== undefined) || i18n.t("settings.payments.required");

export default {
  name: "Payments",
  title() {
    return this.$t("settings.payments.title");
  },
  components: { DataTable },
  data() {
    return {};
  },

  computed: {
    conditionalAction() {
      return {
        revert({ status }) {
          return status=='DONE';
        }
      }
    },
    rules() {
      return {
        name: [required],
      };
    },
    titles() {
      return {
        booking_id: this.$t("settings.payments.booking"),
        captain_username: this.$t("settings.payments.captain"),
        lw_transaction_id: this.$t("settings.payments.transaction"),
        status: this.$t("common.status"),
        payment_type: this.$t("settings.payments.paymentType"),
        total_payments: this.$t("settings.payments.paymentAmount"),
        payment_date: this.$t("settings.payments.creationDate")
      };
    },
    formatter() {
      return {
        payment_date(value) {
          return moment(value).format("DD-MM-YYYY  HH:mm");
        }
      };
    },
    actionsExtraMain() {
      return {

        revert: {
          title: this.$t("settings.payments.revertPayment"),
          icon: "delete_forever",
          action: (item) => {
            this.loading = true;
            this.$dialova({
              title: this.$t("settings.payments.revertPayment"),
              paragraph: this.$t("settings.payments.confirmRevert"),
              loader: true,
            })
              .then(({ close }) => {
                this.axios
                  .post(`payments/revert`, { transaction_id: item.lw_transaction_id })
                  .then(() => {
                    this.$refs.paymentsDataTable.getData();
                    window.getApp.$emit(
                      "SHOW_TOAST",
                      this.$t("settings.payments.revertedSuccessfully"),
                      "green"
                    );
                    // this.$store.commit("DELETE_BESOIN", this.data.id);
                    close();
                  })
                  .catch((err) => {
                    window.getApp.$emit("SHOW_TOAST", err.response.data.message || this.$t("settings.payments.errorOccurred"), "red");
                    close();
                  });
              })
              .catch(() => {
                console.log("cancelled");
              });

          },
        },
      };
    },
  },
};
</script>
